/**
 * Narrows a JobShop's settings to what a locked visitor may see (JET-2155):
 * name, locale, logo, favicon, fonts and the CTA button's colours. This is
 * an allow-list on purpose — the result reaches the Nuxt payload, so a field
 * added to the settings later stays out until someone adds it here.
 *
 * Pass the colour-resolved settings (see utils/colorSlots.ts), so the colours
 * are the palette's current hex values rather than whatever the cache froze.
 */
export function pickPasswordGateBranding(jobShop: JobShop | null | undefined): PasswordGateBranding | null {
  if (!jobShop)
    return null

  const general = jobShop["fonts-and-colors"]?.config?.general
  const branding = jobShop.branding?.config?.general
  const navigation = jobShop.navigation?.config

  // The form shows the logo as an <img>, so a video logo is left out.
  const logo = branding?.logo?.media

  return {
    "title": jobShop.jobShopTitle ?? "",
    "locale": jobShop.locale ?? "",
    "logoUrl": logo?.url && logo.mediaType !== "video" ? logo.url : null,
    "faviconUrl": branding?.favicon?.media?.url || null,
    "fonts-and-colors": {
      config: {
        general: {
          fonts: general?.fonts,
          fontWeights: general?.fontWeights,
          fontAdjustments: general?.fontAdjustments,
        },
      },
    },
    "button": {
      textColor: navigation?.ctaButton?.textColor?.value || null,
      backgroundColor: navigation?.ctaButton?.backgroundColor?.value || null,
    },
  }
}
